// extracted by mini-css-extract-plugin
export default {"container":"PedidoPDF_container__3M4A2","btns":"PedidoPDF_btns__DSZbZ"};